require('./components.module');

require('./administrator');
require('./agent');
require('./auth');
require('./auth-interceptor');
require('./autocomplete');
require('./bus');
require('./bus-schema');
require('./checkbox');
require('./city');
require('./client');
require('./country');
require('./currency');
require('./discount');
require('./draw-line');
require('./infinite-scroll');
require('./line');
require('./office');
require('./page-heading');
require('./price');
require('./promotion');
require('./radio-button');
require('./report');
require('./responsive-table');
require('./sale');
require('./select-field');
require('./discount-field');
require('./sidebar');
require('./station');
require('./sub-line');
require('./ticket');
require('./toast');
require('./user');
require('./validator');
require('./payment');
require('./token');
require('./request-manager');
require('./date-parser');



/** WEBPACK FOOTER **
 ** ./client/components/index.js
 **/